document.addEventListener('turbolinks:load', function() {
    const bookIsbnInput = document.getElementById('book_isbn');

    if (!bookIsbnInput) return;

    const codeScannerButton = document.getElementById('barcode-scanner');
    const barcodeScannerModal = document.getElementById('barcode-scanner-modal');
    const cameraSelectionList = document.getElementById('camera-selector');
    const barcodeScannerSpinner = document.getElementById('barcode-scanner-spinner');

    if (codeScannerButton !== null) {
        codeScannerButton.addEventListener('click', handleCodeScannerButtonClick);
    }

    const html5QrCode = new Html5Qrcode("reader", { formatsToSupport: [ Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.EAN_8 ] });

    function handleCodeScannerButtonClick() {
        const myModal = new bootstrap.Modal(barcodeScannerModal, {
            keyboard: false
        });

        myModal.show();

        async function stopAndClearCamera() {
            if (html5QrCode.isScanning) {
                await html5QrCode.stop();
                await html5QrCode.clear();
            }
        }

        barcodeScannerModal.addEventListener('hidden.bs.modal', async (event) => {
            await stopAndClearCamera();
        });

        function onScanSuccess(decodedText, decodedResult) {
            bookIsbnInput.value = decodedText;
            myModal.hide();

            const inputEvent = new Event('input', {
                bubbles: true,
                cancelable: true,
            });

            bookIsbnInput.dispatchEvent(inputEvent);
        }

        let qrboxFunction = function(viewfinderWidth, viewfinderHeight) {
            return {
                width: viewfinderWidth*0.8,
                height: viewfinderHeight*0.5
            };
        }

        const config = { fps: 10, qrbox: qrboxFunction };

        async function cameraSelectionHandler(cameraButton) {
            const cameraId = cameraButton.target.getAttribute('data-value');

            localStorage.setItem('selectedCameraId', cameraId);

            try {
                barcodeScannerSpinner.style.display = 'block';
                await stopAndClearCamera();
                await html5QrCode.start(cameraId, config, onScanSuccess, null);
                barcodeScannerSpinner.style.display = 'none';
            }catch (e) {
                console.error(e);
            }
        }

        Html5Qrcode.getCameras().then(deviceCameras => {
            if (deviceCameras && deviceCameras.length) {
                let mobileDevice = false;
                const listOfCamerasWithDetails = [];
                const cameraLabelRegex = /camera([0-9]) ([0-9]), facing (front|back)/g;

                for (let cameraIndex = 0; cameraIndex < deviceCameras.length; cameraIndex++) {
                    const cameraLabel = deviceCameras[cameraIndex].label.toLowerCase();
                    const cameraId = deviceCameras[cameraIndex].id;

                    let deviceType = undefined;
                    let cameraNumber = undefined;
                    let cameraNumberIndex = undefined;
                    let cameraFacing = undefined;

                    const matches = [...cameraLabel.matchAll(cameraLabelRegex)];
                    if (matches.length > 0) {
                        deviceType = 'mobile';
                        mobileDevice = true;
                        cameraNumber = matches[0]['1'];
                        cameraNumberIndex = matches[0]['2'];
                        cameraFacing = matches[0]['3'];
                    }else {
                        // not in the expected format, search for a substring

                        if (cameraLabel.indexOf('back') !== -1){
                            cameraFacing = 'back';
                        } else if (cameraLabel.indexOf('front') !== -1){
                            cameraFacing = 'front';
                        }

                        cameraNumber = cameraIndex;
                        cameraNumberIndex = cameraIndex;

                        if (cameraFacing !== undefined) {
                            deviceType = 'mobile';
                            mobileDevice = true;

                        }else{
                            deviceType = 'PC';
                        }
                    }

                    if (cameraFacing !== 'front') {
                        listOfCamerasWithDetails.push({
                            deviceType,
                            cameraId,
                            cameraNumber,
                            cameraNumberIndex,
                            cameraFacing
                        });
                    }
                }

                if (mobileDevice){
                    listOfCamerasWithDetails.sort((camera1, camera2) => {
                        if (camera1.cameraFacing === 'back' && camera2.cameraFacing === 'front') {
                            return -1;
                        }else if (camera1.cameraFacing === 'back' && camera2.cameraFacing === 'back'){
                            if (camera1.cameraNumberIndex < camera2.cameraNumberIndex) {
                                return -1;
                            } else {
                                return 1;
                            }
                        }else if (camera1.cameraFacing === 'front' && camera2.cameraFacing === 'front'){
                            return 0;
                        }else if (camera1.cameraFacing === 'front' && camera2.cameraFacing === 'back'){
                            return 1;
                        }else {
                            return 0;
                        }
                    });
                }

                const cameraButtons = [];
                const previouslySelectedCamera = localStorage.getItem('selectedCameraId');
                let cameraButtonIndexToClick = undefined;

                for (let cameraIndex = 0; cameraIndex < listOfCamerasWithDetails.length; cameraIndex++){
                    const camera = listOfCamerasWithDetails[cameraIndex];
                    const cameraButtonInput = document.createElement('input');
                    const cameraButtonLabel = document.createElement('label');

                    const inputId = 'set_camera_' + (cameraIndex+1).toString();

                    cameraButtonInput.type = 'radio';
                    cameraButtonInput.className = 'btn-check';
                    cameraButtonInput.name = 'camera_id';
                    cameraButtonInput.id = inputId;
                    cameraButtonInput.setAttribute('autocomplete', 'off');

                    if (camera.cameraId == previouslySelectedCamera || (previouslySelectedCamera === null && cameraIndex === 0)) {
                        cameraButtonInput.setAttribute('checked', 'checked');
                        cameraButtonIndexToClick = 2*cameraIndex + 1; // Click on label, not input
                    }

                    cameraButtonLabel.className = 'btn btn-outline-primary';
                    cameraButtonLabel.setAttribute('for', inputId);
                    cameraButtonLabel.innerText = (cameraIndex+1).toString();
                    cameraButtonLabel.setAttribute('data-value', camera.cameraId);
                    cameraButtonLabel.onclick = cameraSelectionHandler;

                    cameraButtons.push(cameraButtonInput);
                    cameraButtons.push(cameraButtonLabel);
                }
                cameraSelectionList.replaceChildren(...cameraButtons);

                if (cameraButtonIndexToClick === undefined){
                    cameraButtonIndexToClick = 1;
                }

                if (cameraButtons.length > 0){
                    const clickEvent = new Event('click', {
                        bubbles: true,
                        cancelable: true,
                    });

                    cameraButtons[cameraButtonIndexToClick].dispatchEvent(clickEvent);
                }
            }
        }).catch(err => {
            console.error(err);
        });
    }
});